import {PModuleType} from '@/enums/configs';
import measurementsModule from '@/store/modules/entities/measurementsModule';
import {moduleTypeToIdMap} from '@/store/modules/enumsModule';

export function getDeviceChangedMessage(item: any) {
  if (
    item.module == PModuleType.DtcpServerModule ||
    item.module == PModuleType.PingerModule ||
    item.module == PModuleType.DtcpEmulatorModule
  ) {
    return `Устройство с мак-адресом ${item.content.mac} было ${
      item.content.status ? 'включено.' : 'выключено.'
    }`;
  } else return item.eventName;
}

export function getErrorOccurredMessage(item: any) {
  const item_module = typeof item.module == 'string' ? moduleTypeToIdMap[item.module] : item.module;
  if (
    [
      PModuleType.HeaterMonitorModule,
      PModuleType.MonitorStatesTasks,
      PModuleType.MonitorBoundaryTasks,
      PModuleType.MonitorChildTasks,
    ].indexOf(item_module) >= 0
  ) {
    switch (item.code) {
      case 21:
        if (item.level)
          return 'Невозможно определить статус узла. Проверьте настройки получения данных.';
        return 'Решена проблема невозможности определения статуса узла.';
      default:
        return item?.content?.message ?? 'Нет данных';
    }
  }
  if (item.module == PModuleType.DtcpServerModule) {
    return item.content.message;
  }
  if (
    item.module == PModuleType.DtcpAccelerometerModule ||
    item.module == PModuleType.DtcpTahoModule ||
    item.module == PModuleType.DtcpTemperatureModule ||
    item.module == PModuleType.DtcpEnergyModule
  ) {
    switch (item.code) {
      case 0:
        if (item.level) return 'Устройство начинает работу после подачи питания.';
        return 'Решена проблема начала устройством работы после подачи питания.';
      case 1:
        if (item.level) return 'Устройство возобновило работу после команды сервера.';
        return 'Решена проблема возобновления устройством работы после команды сервера.';
      case 2:
        if (item.level) return 'Устройство возобновило работу после сброса по прерыванию.';
        return 'Решена проблема возобновления устройством работы после сброса по прерыванию.';
      case 3:
        if (item.level)
          return 'Зафиксировано физическое отключение устройства от локально-вычислительной сети.';
        return 'Решена проблема физического отключения устройства от локально-вычислительной сети.';
      case 16:
        if (item.level) return 'Сбой в работе датчика. Потеряна связь с датчиком.';
        return 'Решена проблема сбоя в работе датчика при потери связи с датчиком.';
      case 17:
        if (item.level) return 'Сбой в работе датчика. Аппаратная ошибка устройства.';
        return 'Решена проблема сбоя в работе датчика при аппаратной ошибке устройства.';
      case 19:
        if (item.level) return 'Сбой в работе устройства. Нехватка оперативной памяти устройства.';
        return 'Решена проблема сбоя в работе устройства при нехватке оперативной памяти устройства.';
      case 253:
        if (item.level) return 'Устройство будет производить перезагрузку перед обновлением ПО.';
        return 'Решена проблема перезагрузки устройства перед обновлением ПО.';
      default:
        return 'Неизвестная ошибка.';
    }
  } else return item.eventName;
}

/**
 * Отрисовка текста сообщения для события boundary_passed
 * @param item содержание события
 * @return Текстовое сообщение
 */
export function getBoundaryPassedMessage(item: any) {
  if (!('content' in item) || !('boundary_id' in item.content)) {
    return item.eventName;
  }
  const boundaries = measurementsModule.all.filter(x => x.id == item.content.boundary_id);
  let boundary_name = '';
  if (boundaries.length > 0) {
    boundary_name = boundaries[0].name;
  } else {
    return item.eventName;
  }
  switch (item.level) {
    case 0:
      return `Значение измерения "${boundary_name}" в норме`;
    case 1:
      return `Значение измерения "${boundary_name}" достигло зоны предупреждения`;
    case 2:
      return `Значение измерения "${boundary_name}" достигло зоны опасности`;
    case 3:
      return `Значение измерения "${boundary_name}" достигло зоны ошибки`;
    default:
      return item.eventName;
  }
}
